const content = {
  inputs: [
    {
      placeholder: "Full Name",
      name: "fullname",
      type: "text",
    },
    {
      placeholder: "Email",
      name: "email",
      type: "email",
    },

    {
      placeholder: "Password",
      name: "password",
      type: "password",
    },
    {
      placeholder: "Project Name",
      name: "project",
      type: "text",
    },
  ],
};

export default content;